import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import VueMeta from 'vue-meta'
// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
// import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
// import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
// import others from './routes/others'

Vue.use(VueRouter)
Vue.use(VueMeta)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'pages-landing' } },
    ...apps,
    // ...dashboard,
    ...pages,
    // ...chartsMaps,
    // ...formsTable,
    // ...uiElements,
    // ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  store.commit('app/startLoading')

  const isLoggedIn = await isUserLoggedIn()

  // nav menu visibility (unchanged)
  store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', !isLoggedIn)

  const isSafePath = p => typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !/^https?:\/\//i.test(p)

  // avoid redirect ping-pong with the listener
  let loginPending = false
  try { loginPending = sessionStorage.getItem('auth.loginRedirectPending') === '1' } catch (_) {}

  // If already logged in, consume one-shot returnTo first
  if (isLoggedIn) {
    let storedRt = null
    try { storedRt = sessionStorage.getItem('auth.returnTo') } catch (_) {}
    if (isSafePath(storedRt) && storedRt !== to.fullPath) {
      try { sessionStorage.removeItem('auth.returnTo') } catch (_) {}
      return next(storedRt)
    }
  }

  // ACL protection
  if (!canNavigate(to)) {
    if (!isLoggedIn) {
      // listener is redirecting? don't fight it
      if (loginPending) return next()
      const target = isSafePath(to.fullPath) ? to.fullPath : '/'
      try { sessionStorage.setItem('auth.returnTo', target) } catch (_) {}
      return next({ name: 'auth', query: { returnTo: target, form: 'register' } })
    }
    return next({ name: 'misc-not-authorized' })
  }

  // If not logged in and already heading to login, let it flow
  if (!isLoggedIn && (to.name === 'auth' || to.path === '/auth')) {
    return next()
  }

  // If logged in and goes to /login → send to returnTo or home
  if (isLoggedIn && (to.name === 'auth' || to.path === '/auth')) {
    let storedRt = null
    try { storedRt = sessionStorage.getItem('auth.returnTo') } catch (_) {}
    if (isSafePath(storedRt)) return next(storedRt)
    return next(getHomeRouteForLoggedInUser())
  }

  // Redirect away from guest-only pages when logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const rt = typeof to.query?.returnTo === 'string' ? to.query.returnTo : null
    return next(isSafePath(rt) ? rt : getHomeRouteForLoggedInUser())
  }

  return next()
})

router.afterEach(to => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) appLoading.style.display = 'none'
  if (to.meta?.waitForReady) return
  setTimeout(() => store.commit('app/stopLoading'), 0)
})

export default router
